import { Icon } from '@iconify/react'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { ModalFooter } from '../styles/ModalPrimitives'

const Overlay = styled.div`
   position: fixed;
   inset: 0;
   background: rgba(0, 0, 0, 0.5);
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 9999;
   opacity: 0;
   transition: opacity 0.2s ease;
`

const Modal = styled.div`
   background: white;
   border-radius: 16px;
   width: 90%;
   max-width: 400px;
   overflow: hidden;
`

const Header = styled.div`
   padding: 18px;
   display: flex;
   align-items: center;
   gap: 12px;
   border-bottom: 1px solid #E7E7E9;
`

const IconWrap = styled.div`
   width: 40px;
   height: 40px;
   border-radius: 50%;
   background: #FEF2F2;
   display: flex;
   align-items: center;
   justify-content: center;
   color: #DC2626;
`

const Content = styled.div`
   padding: 18px;
`

const Title = styled.h3`
   font-size: 16px;
   font-weight: 600;
   color: #18181B;
   margin: 0;
`

const Description = styled.p`
   font-size: 14px;
   color: #71717A;
   margin: 8px 0 0 0;
`

const ConfirmButton = styled.button`
   background: #DC2626;
   color: white;
   border: 0;

   &:hover {
      background: #B91C1C;
   }
`

interface SignOutModalProps {
   open: boolean
   onClose: () => void
   onConfirm: () => void
}

export default function SignOutModal({ open, onClose, onConfirm }: SignOutModalProps): React.JSX.Element | null {
   const overlayRef = useRef<HTMLDivElement>(null)

   useEffect(() => {
      if (open && overlayRef.current) {
         overlayRef.current.style.display = 'flex'
         setTimeout(() => {
            if (overlayRef.current) overlayRef.current.style.opacity = '1'
         }, 10)
      } else if (overlayRef.current) {
         overlayRef.current.style.opacity = '0'
         setTimeout(() => {
            if (overlayRef.current) overlayRef.current.style.display = 'none'
         }, 200)
      }
   }, [open])

   if (!open) return null

   return (
      <Overlay ref={overlayRef} onClick={onClose}>
         <Modal onClick={(e) => e.stopPropagation()}>
            <Header>
               <IconWrap>
                  <Icon icon="solar:logout-2-outline" width={20} />
               </IconWrap>
               <Title>Sign Out</Title>
            </Header>
            <Content>
               <Description>Are you sure you want to sign out? You'll need to log in again to access your account.</Description>
            </Content>
            <ModalFooter>
               <button className="cancel" onClick={onClose}>Cancel</button>
               <ConfirmButton onClick={onConfirm}>Sign Out</ConfirmButton>
            </ModalFooter>
         </Modal>
      </Overlay>
   )
}
